// extracted by mini-css-extract-plugin
export default {"ActionList_LinkItem":"LinkedBranches-module__ActionList_LinkItem--wbhvK","ActionList_LeadingVisual":"LinkedBranches-module__ActionList_LeadingVisual--SZUjq"};